class CategoryService {
    constructor(categories) {
        this.className = 'CategoryService';
        this.categories = categories;
    }

    getCategoryMinimunQuantityForDelivery(categoryId) {
        let category = this.categories.find(i => i.id === categoryId)
        return category ? category.minimumDeliveryQuantity : 0

    }

    getCategoryMinimunQuantityForTakeAway(categoryId) {
        let category = this.getCategoryById(categoryId)
        return category ? category.minimumTakeAwayQuantity : 0
    }


    get getCategoryById() {
        return (categoryId) => {
            return this.categories.find(i => i.id === categoryId)
        }
    }

    get getCategoryNameById() {
        return (id) => {
            let category = this.categories.find(i => i.id === id)
            return category ? category.name : null
        }
    }
}

export default CategoryService;
